import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [
    {
      tagId: "11111",
      tagName: "Tag1"
    },
    {
      tagId: "22222",
      tagName: "Tag2"
    },
    {
      tagId: "33333",
      tagName: "Tag3"
    },
  ]
};

export const portTagsSlice = createSlice({
  name: "portTags",
  initialState,
  reducers: {},
});

export const {} = portTagsSlice.actions;

export default portTagsSlice.reducer;
